import { useState } from 'react'
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons'
import {
  GridRowColumn,
  IconButton,
  Link,
  Text,
} from '@/componentsV1/BaseComponents'
import { useReselector } from '@/utils/sharedHooks'
import { getUserDocumentById } from '@/features/user/your-practice/documents/lib/userDocuments.selector'
import DeleteDocumentModal from './DeleteDocumentModal'

const UploadedDocument = ({
  id,
  readOnly,
}: {
  id: number
  readOnly?: boolean
}) => {
  const userDoc = useReselector(getUserDocumentById, id)
  const [openModal, setOpenModal] = useState(false)
  return (
    <GridRowColumn
      key={userDoc?.id}
      short
      columnStyle={{
        display: 'flex',
        flexDirection: 'row',
        verticalAlign: 'middle',
        justifyContent: 'end',
        gap: 6,
        alignItems: 'center',
      }}
    >
      {!userDoc?.signedUrl && <Text>{userDoc?.fileDescription}</Text>}
      {userDoc?.signedUrl && (
        <Link href={userDoc.signedUrl}>{userDoc?.fileDescription}</Link>
      )}
      {!readOnly && (
        <IconButton onClick={() => setOpenModal(true)} icon={faTrashCan} />
      )}
      <DeleteDocumentModal
        open={openModal}
        close={() => setOpenModal(false)}
        documentId={id}
      />
    </GridRowColumn>
  )
}

export default UploadedDocument
